import { render } from "./JWTagInput.vue?vue&type=template&id=3c393626&scoped=true&ts=true"
import script from "./JWTagInput.vue?vue&type=script&lang=ts"
export * from "./JWTagInput.vue?vue&type=script&lang=ts"

import "./JWTagInput.vue?vue&type=style&index=0&id=3c393626&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c393626"]])

export default __exports__